import { Locales } from "@simplyk/common";

import type { OrganizationAssistantPage } from "./buildOrganizationAssistantPage";

import { trpc } from "@/common/helpers/trpc";
import { AssistantChatTransportOptions, createTrpcChatTransport } from "@/features/Assistant/helpers/trpcChatTransport";

type TrpcClient = ReturnType<typeof trpc.useUtils>["client"];

interface OrganizationStreamContext {
  locale: Locales;
  page: OrganizationAssistantPage;
}

type OrganizationAssistantTransportOptions = Omit<
  AssistantChatTransportOptions<OrganizationStreamContext, Record<never, never>>,
  "getMessageTurnExtras"
> & { organizationId: string };

export const createOrganizationAssistantTransport = (
  client: TrpcClient,
  { organizationId, ...options }: OrganizationAssistantTransportOptions
) =>
  createTrpcChatTransport<OrganizationStreamContext>(
    {
      send: (input) => client.sendOrganizationAssistantMessage.mutate({ ...input, organizationId }),
      stream: (input, handlers) =>
        client.streamOrganizationAssistantTurn.subscribe({ ...input, organizationId }, handlers),
      getConversation: (input) => client.getOrganizationAssistantConversation.query({ ...input, organizationId }),
      cancel: (input) => client.cancelOrganizationAssistantTurn.mutate({ ...input, organizationId }),
    },
    options
  );
